/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const CHALLENGE_ISSUE_SOURCES = ['admin', 'user'] as const;

export const challengeIssueSourceSchema = z.enum(CHALLENGE_ISSUE_SOURCES);

export type IChallengeIssueSource = z.infer<typeof challengeIssueSourceSchema>;
